export const getImageValidationLimits = () => {
  return {
    maxFileSizeKB: null, // Remove file size limit
    maxDimension: 512,
  }
}

export const validateAndResizeImage = async (file: File): Promise<File> => {
  return new Promise((resolve, reject) => {
    // Remove file size validation - only check file type
    if (!file.type.startsWith("image/")) {
      reject(new Error("Please select a valid image file"))
      return
    }

    const img = new Image()
    img.crossOrigin = "anonymous"

    img.onload = () => {
      try {
        // Always resize to 512x512
        const canvas = document.createElement("canvas")
        const ctx = canvas.getContext("2d")

        if (!ctx) {
          reject(new Error("Failed to create canvas context"))
          return
        }

        canvas.width = 512
        canvas.height = 512

        // Draw image to fill the entire 512x512 canvas
        ctx.drawImage(img, 0, 0, 512, 512)

        canvas.toBlob(
          (blob) => {
            if (blob) {
              const resizedFile = new File([blob], file.name, {
                type: "image/jpeg",
                lastModified: Date.now(),
              })
              resolve(resizedFile)
            } else {
              reject(new Error("Failed to resize image"))
            }
          },
          "image/jpeg",
          0.9, // High quality
        )
      } catch (error) {
        reject(new Error("Failed to process image"))
      }
    }

    img.onerror = () => {
      reject(new Error("Failed to load image"))
    }

    img.src = URL.createObjectURL(file)
  })
}
